import { baseApi } from "../redux/baseAPI";
import { parseResponse } from "../utils/common_lib";

export const settingApi = baseApi.injectEndpoints({
  tagTypes: ["FacilityLocationGroups"],
  endpoints: (builder) => ({
    getFacilityLocationGroups: builder.query({
      query: (params) => ({
        url: `/nursing_home_management/get_groups_list.json`,
        method: "GET",
        params: params,
      }),
      providesTags: ["FacilityLocationGroups"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),

    getGroupById: builder.query({
      query: (params) => ({
        url: `/nursing_home_management/get_group_by_id.json`,
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),

    saveFacilityLocationGroup: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/save_group.json`,
        method: "POST",
        data: body,
        body: body,
      }),
      invalidatesTags: ["FacilityLocationGroups"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),

    deleteFacilityLocationGroup: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_management/delete_group.json`,
        method: "POST",
        data: body,
        body: body,
      }),
      invalidatesTags: ["FacilityLocationGroups"],
      transformResponse: (response, meta, arg) => parseResponse(response),
    }),
  }),
});

export const {
  useGetFacilityLocationGroupsQuery,
  useGetGroupByIdQuery,
  useLazyGetGroupByIdQuery,
  useSaveFacilityLocationGroupMutation,
  useDeleteFacilityLocationGroupMutation,
} = settingApi;
